import PropTypes from 'prop-types';
import React from 'react';
import _set from 'lodash/set';

import Button from 'ravenjs/lib/Button';
import Col from 'ravenjs/lib/Col';
import Input from 'ravenjs/lib/Input';
import Row from 'ravenjs/lib/Row';
import { callFunc, get, getHandler } from 'ravenjs/utils';
import { isEmpty } from 'ravenjs/utils/lodash';

import DisplayRequiredWithIconField from './DisplayRequiredWithIconField';

class InputWithButton extends React.Component {
    static propTypes = {
        disabled: PropTypes.bool,
        idSchema: PropTypes.object.isRequired,
        formContext: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        readonly: PropTypes.bool,
        registry: PropTypes.object.isRequired,
        required: PropTypes.bool,
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.object.isRequired,
        formData: PropTypes.string,
        onBlur: PropTypes.func,
    };

    static defaultProps = {
        disabled: null,
        readonly: null,
        required: null,
        formData: '',
        onBlur: () => {},
    };

    constructor(props) {
        super(props);

        this.inputRef = React.createRef();

        // Bindings.
        this.handleOnClick = this.handleOnClick.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    /**
     * Get the `ui:options` for the current field.
     *
     * @method _getUiOptions
     * @private
     * @param  {Object}      schema The schema to extract the options from
     * @return {Object}             The extracted options
     */
    _getUiOptions = schema => get(schema, 'ui:options', {});

    onInputChange({ target: { value } }) {
        const {
            formContext,
            idSchema: { $id },
            onChange,
        } = this.props;
        const formData = { ...formContext.getFormData() };
        onChange(value);
        const path = $id.split('_').splice(1);

        _set(formData, path.join('.'), value);
        formContext.updateFormData({ formData });
    }

    async handleOnClick(event) {
        event.preventDefault();
        const { formContext } = this.props;
        const handlers = get(formContext, 'handlers', {});
        const actionInputButton = getHandler(handlers, 'actionInputButton');
        const inputValue = await callFunc(actionInputButton);
        const code = get(inputValue, 'code', '');
        // To Update input value.
        this.inputRef.current.value = code;
        // To update parent formData.
        const { onChange } = this.props;
        onChange(code);
    }

    render() {
        const {
            disabled: disabledProps,
            idSchema,
            formData,
            name,
            readonly,
            registry,
            required,
            schema,
            uiSchema,
            formContext,
            onBlur,
        } = this.props;
        // Determine if the field is disabled
        const disabled = readonly || disabledProps;
        // Extract couple of fields from the props.
        const options = this._getUiOptions(uiSchema);
        const title = get(schema, 'title') || name;
        const TitleField = get(registry, 'fields.FormGroupTitleField', () => <></>);
        const { $id: id } = idSchema;
        const { btnProps = {}, btnLabel = '' } = options;
        const isRequired = required && isEmpty(formData);
        const pristine = get(formContext, 'pristine', false);
        const taintedFields = get(formContext, 'taintedFields', []);
        const showRequired = (!pristine || taintedFields.includes(id)) && isRequired;
        const inputDisabled = options.disabledInput;

        // Render the `FileField` component.
        return (
            <>
                <Row width="auto">
                    <Col size={12}>
                        <TitleField id={id} title={title} required={showRequired} />
                    </Col>
                    <Col style={{ position: 'relative' }}>
                        <Input
                            required={isRequired}
                            type="text"
                            ref={this.inputRef}
                            onChange={this.onInputChange}
                            defaultValue={formData}
                            showRequired={showRequired}
                            onBlur={
                                typeof onBlur === 'function' &&
                                (event => onBlur(id, event.target.value))
                            }
                            disabled={inputDisabled}
                        />
                    </Col>
                    <Col size="auto">
                        <Button
                            disabled={disabled}
                            onClick={this.handleOnClick}
                            type="button"
                            {...btnProps}
                        >
                            {btnLabel}
                        </Button>
                    </Col>
                </Row>
                {showRequired && <DisplayRequiredWithIconField />}
            </>
        );
    }
}

export default InputWithButton;
